import { CommonModule } from "@angular/common";
import { ModuleWithProviders, NgModule, inject } from "@angular/core";

import { LoadExternalUrlService } from "./load-external-url.service";

@NgModule({
    imports: [CommonModule],
})
export class LoadExternalUrlStateModule {
    constructor() {
        const parentModule = inject(LoadExternalUrlStateModule, {
            optional: true,
            skipSelf: true,
        });

        if (parentModule) {
            throw new Error(
                "LoadExternalUrlStateModule is already loaded. Import it in the AppModule only",
            );
        }
    }

    public static forRoot(): ModuleWithProviders<LoadExternalUrlStateModule> {
        return {
            ngModule: LoadExternalUrlStateModule,
            providers: [LoadExternalUrlService],
        };
    }
}
